export enum AppUserRole {
  None,
  Admin,
  Leader,
  User,
  Customer
}
